import { Spin } from 'antd'
import React from 'react'
import { SpinSize } from 'antd/lib/spin'
import { useScroll } from '~/hooks/useScroll'
import _ from 'lodash'
import styled from 'styled-components'

const ViewWrapper = styled.div`
  .ant-spin-spinning {
    display: block;
    text-align: center;
    margin: 64px auto;
  }
`
export type InfiniteProps = {
  hasNextPage: boolean
  onScroll: () => void
  loading: boolean
  root?: Element | null
  spinSize?: SpinSize
  spinStyle?: React.CSSProperties
}

/**
 * @deprecated 不推荐使用，建议用～/hooks/useInfiniteScroll. 不是真的废弃了.
 */
export const InfiniteScroll: React.FC<InfiniteProps> = ({
  hasNextPage,
  onScroll,
  loading,
  root,
  spinSize = 'large',
  spinStyle,
}) => {
  const [targetRef] = useScroll({
    onLoadMore: onScroll,
    canLoadMore: hasNextPage,
    root: root,
  })

  return (
    <ViewWrapper ref={targetRef}>
      {hasNextPage ? (
        <>{loading && <Spin size={spinSize} style={spinStyle} />}</>
      ) : null}
    </ViewWrapper>
  )
}
